import React, { Component } from "react";
import { withRouter } from "react-router";
import { ListContainer, Footer, Box, TagBox } from "./style";
import { connect } from "react-redux";
import Button from "../../../../../components/button";
import MoreMenu from "../../../../../components/moreMenu";
import { Modal } from "../../../../../components/modal";
import Form from "../../../../../containers/projectList/form";
import { isEqual } from "lodash";
import { reduxForm } from "redux-form";
import { Confirm } from "../../../../../components/confirm";
import { BoxLoading } from "../../../../../components/loading/components/boxLoading";
import ProjectState from "../../../../../constants/projectState";
import * as ProjectAction from "../../../../../actions/project";
import * as ProvinceAction from "../../../../../actions/province";
import { ProjectType } from "../../../../../constants/projectType";
import NewProjectDeniedModal from "../../../../../containers/app/components/accessDeniedOrReminderModals/newProjectDeniedModal";
import {
  EXPIRED_PREMIUM,
  FREE,
  NEAR_ENDING_PREMIUM,
  PREMIUM,
  STATE_NAMES
} from "../../../../../constants/premiumState";
import GuestsDeniedModal from "../../../../../containers/app/components/accessDeniedOrReminderModals/guestsDeniedModal";
import logout from "../../../../../assets/logout";

class ProjectList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      moreMenu: false,
      showModal: false,
      projectsData: "",
      originProjectsData: "",
      showArchiveConfirm: false,
      projectArchiveData: "",
      modalMode: "add",
      editProjectId: "",
      editProjectName: "",
      confirm_show: false,
      editedProject: "",
      originEditedProject: "",
      showShareProjectConfirm: false,
      newProjectDeniedModalShow: false,
      accessDeniedModalShow: false,
      newProjectLimit: "",
      clickedProjectId: "",
      userInfoModal: false
    };
    this.modalToggle = this.modalToggle.bind(this);
    this.editProject = this.editProject.bind(this);
    this.newProjectButtonHandler = this.newProjectButtonHandler.bind(this);
  }
  componentDidMount() {
    if (!this.props.projects.is_fetched) {
      this.props.getProjects();
    }
  }
  static getDerivedStateFromProps(props, state) {
    let result = [];
    if (!isEqual(props.projects.data, state.originProjectsData)) {
      result.projectsData = props.projects.data;
      result.originProjectsData = props.projects.data;
      result.showModal = false;
    }
    if (!isEqual(props.editedProject, state.originEditedProject)) {
      result.editedProject = props.editedProject;
      result.originEditedProject = props.editedProject;
      result.showModal = false;
      result.moreMenu = false;
    }
    // if (props.deletedProjectId !== state.originDeletedProjectId) {
    //   result.originDeletedProjectId = props.deletedProjectId;
    //   result.showConfirm = false;
    //   result.moreMenu = false;
    // }
    return result;
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.archiveProjectLoading !== this.props.archiveProjectLoading &&
      !this.props.archiveProjectLoading
    ) {
      this.setState({ showArchiveConfirm: false });
    }
  }

  projectClickHandler(project) {
    const lastProjectId = localStorage.getItem("project_id");
    if (parseInt(lastProjectId) !== parseInt(project.project.id)) {
      localStorage.setItem(
        "project_info",
        JSON.stringify({ ...project.project, is_owner: project.is_owner })
      );
      localStorage.setItem("project_id", project.project.id);
      window.location.replace("/");
    }
    this.props.close();
  }
  modalToggle() {
    const { showModal } = this.state;
    this.props.initialize({
      name: "",
      type: "",
      state_id: "",
      city_id: "",
      start_date: "",
      description: "",
      currency: ""
    });
    this.setState({ showModal: !showModal, modalMode: "add" });
  }
  archiveProject(project) {
    if (project && project.project)
      this.props.archiveProject(project.project.id, { archive_state: true });
  }
  editProject(project) {
    const { showModal } = this.state;
    let state = null;
    let city = null;
    let type = null;
    let start_date = null;
    let description = null;
    if (project.project.state !== null) {
      state = {
        key: project.project.state !== null ? project.project.state.id : "",
        value: project.project.state !== null ? project.project.state.name : ""
      };
      if (project.project.state) {
        this.props.getCity({
          id: project.project.state.id,
          name: project.project.state.name
        });
      }
    }
    if (project.project.city !== null) {
      city = {
        key: project.project.city.id,
        value: project.project.city.name
      };
    }
    if (project.project.type !== null) {
      type = ProjectType.filter(type => type.key === project.project.type)[0];
    }
    if (project.project.start_date !== null) {
      start_date = project.project.start_date;
    }
    if (project.project.description !== null) {
      description = project.project.description;
    }
    this.setState(
      {
        moreMenu: false,
        showModal: !showModal,
        modalMode: "edit",
        editProjectId: project.project.id,
        editProjectName: project.project.name
      },
      () => {
        this.props.initialize({
          name: project.project.name,
          type: type,
          state_id: state,
          city_id: city,
          start_date: start_date,
          description: description,
          currency: project.project.currency
        });
      }
    );
  }

  submit(values) {
    let data = { ...values };
    data.state_id = values.state_id.key;
    data.city_id = values.city_id.key;
    data.type = values.type.key;
    this.props.updateProject(data, true);
  }
  edit(values) {
    let data = { ...values };
    data.name = values.name;
    data.description = values.description;
    data.state_id = (values.state_id && values.state_id.key) || null;
    data.city_id = (values.city_id && values.city_id.key) || null;
    data.type = values.type.key;
    data.start_date = values.start_date;
    this.props.editProject(data, this.state.editProjectId);
  }
  confirmStatus(status) {
    if (status) {
      this.props.accept(this.state.notification_id);
    } else {
      this.props.reject(this.state.notification_id);
    }
    this.setState({
      confirm_show: false
    });
  }
  newProjectButtonHandler() {
    const { init } = this.props;
    if (
      init.data &&
      init.data.data &&
      !init.data.data.user.name &&
      !init.data.data.user.family
    ) {
      this.setState({ userInfoModal: true });
    } else {
      if (!this.props.projects.loading && init.data && init.data.premium) {
        if (init.data.premium.free_project_remain > 0) {
          this.modalToggle();
        } else {
          this.setState({
            newProjectDeniedModalShow: true,
            newProjectLimit: init.data.premium.free_project_limit
          });
        }
      }
    }
  }
  render() {
    const {
      moreMenu,
      showModal,
      showArchiveConfirm,
      modalMode,
      editProjectName,
      showShareProjectConfirm,
      newProjectDeniedModalShow,
      accessDeniedModalShow,
      newProjectLimit,
      clickedProjectId,
      projectArchiveData,
      userInfoModal
    } = this.state;
    const loading = this.props.projects.loading;
    let projectsData = this.state.projectsData;
    return (
      <React.Fragment>
        {userInfoModal && (
          <Confirm
            show={userInfoModal}
            rejectHandler={() => this.setState({ userInfoModal: false })}
            acceptHandler={() =>
              this.props.history.push("/user-account-setting/edit")
            }
            close={() => this.setState({ userInfoModal: false })}
            content={{
              type: "info",
              title: "اطلاعات کاربری",
              message:
                "برای ایجاد پروژه جدید" +
                " باید اطلاعات کاربری" +
                " خود را تکمیل نمایید." +
                " آیا تمایل به تکمیل" +
                " اطلاعات کاربری خود دارید؟",
              acceptButtonText: "بله",
              rejectButtonText: "خیر",
              icon: "icon mapsa-i-letter"
            }}
          />
        )}
        {showArchiveConfirm && (
          <Confirm
            show={showArchiveConfirm}
            rejectHandler={() => this.setState({ showArchiveConfirm: false })}
            close={() => this.setState({ showArchiveConfirm: false })}
            acceptHandler={() => this.archiveProject(projectArchiveData)}
            content={{
              type: "danger",
              title: "آرشیو پروژه",
              message:
                "با آرشیو پروژه‌ها اطلاعات پروژه شما حذف نخواهد شد و در صورت نیاز می‌توانید آن را از طریق صفحه مدیریت پروژه‌ها مجددا به لیست پروژه‌های فعال خود بازگردانید.",
              acceptButtonText: "آرشیو پروژه",
              rejectButtonText: "انصراف"
            }}
            loading={this.props.archiveProjectLoading}
          />
        )}
        {showModal && (
          <Modal
            show={showModal}
            closeHandler={() => this.modalToggle()}
            body={
              <Box>
                <Form
                  submitButtonText={
                    modalMode === "add" ? "ایجاد پروژه" : "ذخیره"
                  }
                  onSubmit={
                    modalMode === "add"
                      ? this.submit.bind(this)
                      : this.edit.bind(this)
                  }
                  onCancel={() => this.modalToggle()}
                />
              </Box>
            }
            loading={false}
            header={
              modalMode === "add"
                ? {
                    title: "پروژه جدید",
                    icon: "icon mapsa-outline-layers",
                    iconColor: "primary_vivid"
                  }
                : {
                    title: `ویرایش پروژه ${editProjectName}`,
                    icon: "icon mapsa-outline-layers",
                    iconColor: "primary_vivid"
                  }
            }
          />
        )}
        <Confirm
          show={this.state.confirm_show}
          rejectHandler={() => this.confirmStatus(false)}
          acceptHandler={() => this.confirmStatus(true)}
          close={() => {
            this.setState({
              confirm_show: false
            });
          }}
          content={{
            type: "info",
            title: this.state.confirm_title,
            message: this.state.confirm_message,
            comment: this.state.confirm_comment,
            acceptButtonText: "قبول",
            rejectButtonText: "رد",
            icon: "icon mapsa-plus"
          }}
        />
        <Confirm
          show={showShareProjectConfirm}
          rejectHandler={() =>
            this.setState({ showShareProjectConfirm: false })
          }
          close={() => this.setState({ showShareProjectConfirm: false })}
          content={{
            type: "warning",
            icon: "icon mapsa-i-letter",
            message:
              "شما مجاز به ویرایش پروژه اشتراکی نیستید. در صورت نیاز با مالک پروژه تماس بگیرید.",
            rejectButtonText: "باشه"
          }}
        />
        {newProjectDeniedModalShow && (
          <NewProjectDeniedModal
            status={newProjectDeniedModalShow}
            handleShow={show =>
              this.setState({ newProjectDeniedModalShow: show })
            }
            projectNumberLimit={newProjectLimit}
          />
        )}
        {accessDeniedModalShow && (
          <GuestsDeniedModal
            status={accessDeniedModalShow}
            handleShow={show =>
              this.setState({
                accessDeniedModalShow: show
              })
            }
            projectId={clickedProjectId}
          />
        )}
        <ListContainer>
          {!loading && (
            <React.Fragment>
              {projectsData.length !== 0 ? (
                projectsData.map((projects, key) => {
                  let userName = projects.creator_user;
                  if (
                    parseInt(projects.project.id) !==
                      parseInt(localStorage.getItem("project_id")) &&
                    projects.state !== ProjectState.INACTIVE &&
                    !projects.project.is_archived
                  ) {
                    return (
                      <div
                        className="list-items"
                        key={key}
                        onClick={e => {
                          if (
                            projects.state !== ProjectState.PENDING &&
                            projects.state !== ProjectState.INACTIVE_PENDING
                          ) {
                            if (
                              !projects.is_owner &&
                              (projects.project.premium_state === FREE ||
                                projects.project.premium_state ===
                                  EXPIRED_PREMIUM)
                            ) {
                              this.setState({
                                accessDeniedModalShow: true,
                                clickedProjectId: projects.project.id
                              });
                            } else {
                              this.projectClickHandler(projects);
                            }
                          } else {
                            this.setState({
                              notification_id: projects.notification_id,
                              confirm_show: true,
                              confirm_title: "",
                              confirm_message: `کاربر ${userName} ، شما را به پروژه ${projects.project.name} دعوت کرده است.`,
                              confirm_comment: ""
                            });
                          }
                        }}
                      >
                        <div className="text-bar">
                          <div className="project-characteristics">
                            <div className="project-name">
                              <span className="inner-text">
                                {projects.project.name}
                              </span>
                            </div>
                            {projects.project.premium_state !== FREE &&
                              projects.project.premium_state !==
                                EXPIRED_PREMIUM &&
                              !(
                                projects.state === ProjectState.PENDING ||
                                projects.state === ProjectState.INACTIVE_PENDING
                              ) && (
                                <TagBox
                                  type={
                                    projects.project.premium_state ===
                                      PREMIUM ||
                                    projects.project.premium_state ===
                                      NEAR_ENDING_PREMIUM
                                      ? "success"
                                      : "secondary"
                                  }
                                >
                                  {STATE_NAMES[projects.project.premium_state]}
                                </TagBox>
                              )}
                          </div>
                          <div className="user-name">{userName}</div>
                        </div>
                        <div className="icon-bar">
                          <React.Fragment>
                            {projects.state !== ProjectState.PENDING &&
                              projects.state !==
                                ProjectState.INACTIVE_PENDING && (
                                <i
                                  className={
                                    projects.is_owner
                                      ? "list-items-more-icon icon mapsa-more"
                                      : "list-items-more-icon icon mapsa-more list-items-more-icon-disabled " +
                                        (moreMenu === projects.id
                                          ? "pressed "
                                          : "")
                                  }
                                  onClick={
                                    projects.is_owner
                                      ? e => {
                                          e.stopPropagation();
                                          this.setState({
                                            moreMenu: projects.id
                                          });
                                        }
                                      : e => {
                                          e.stopPropagation();
                                          this.setState({
                                            showShareProjectConfirm: true
                                          });
                                        }
                                  }
                                  title={
                                    projects.is_owner
                                      ? ""
                                      : "شما مجاز به ویرایش پروژه اشتراکی نیستید. در صورت نیاز با مالک پروژه تماس بگیرید."
                                  }
                                />
                              )}
                            {projects.is_owner && moreMenu === projects.id && (
                              <MoreMenu
                                close={() => this.setState({ moreMenu: false })}
                                menu={[
                                  {
                                    icon: "mapsa-edit",
                                    text: "ویرایش",
                                    onClick: () => {
                                      this.editProject(projects);
                                    }
                                  },
                                  {
                                    icon: "mapsa-archive-soild",
                                    text: "آرشیو پروژه",
                                    onClick: () => {
                                      this.setState({
                                        projectArchiveData: projects,
                                        showArchiveConfirm: true
                                      });
                                    }
                                  }
                                ]}
                              />
                            )}
                          </React.Fragment>
                          {(projects.state === ProjectState.PENDING ||
                            projects.state ===
                              ProjectState.INACTIVE_PENDING) && (
                            <div className="project-invite">دعوت جدید</div>
                          )}
                        </div>
                      </div>
                    );
                  } else {
                    return <div key={key} />;
                  }
                })
              ) : (
                <div style={{ width: "170px", margin: "0 auto" }}>
                  پروژه‌ی دیگری یافت نشد!
                </div>
              )}
            </React.Fragment>
          )}
          {loading && BoxLoading()}
        </ListContainer>
        <Footer>
          <Button btn="secondary" onClick={this.newProjectButtonHandler}>
            پروژه جدید
          </Button>
          <Button btn="outline" borderless onClick={logout}>
            خروج
          </Button>
        </Footer>
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    editedProject: store.Project.editedProject,
    projects: store.Project,
    loading: store.Project.loading,
    archiveProjectLoading: store.Project.archiveProjectLoading,
    // deletedProjectId: store.Project.deletedProjectId,
    init: store.Init
  };
};

const mapDispatchToProps = dispatch => {
  return {
    accept: id => {
      dispatch(ProjectAction.accept(id));
    },
    reject: id => {
      dispatch(ProjectAction.reject(id));
    },
    getProjects: () => {
      dispatch(ProjectAction.get());
    },
    updateProject: (data, isReload) => {
      dispatch(ProjectAction.store(data, isReload));
    },
    editProject: (data, id) => {
      dispatch(ProjectAction.update(data, id));
    },
    // deleteProject: id => {
    //   dispatch(ProjectAction.deleteReq(id));
    // },
    getCity: data => {
      dispatch(ProvinceAction.getCity(data));
    },
    archiveProject: (id, data) => {
      dispatch(ProjectAction.archive(id, data));
    }
  };
};

ProjectList = reduxForm({
  form: "add_project"
})(ProjectList);

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ProjectList)
);
